export default __webpack_public_path__ + "static/media/medha_krishnagiri.0d676df7.jpeg";